export default function (state, getters, rootState, rootGetters) {
    let setting = rootState.settings.regulars;
    let min = (state.page - 1) * setting.col;
    let max = state.page * setting.col - 1;
    let i = 0;
    return state.items.filter(j => {
        let a = (i >= min && i <= max);
        i++;
        return a;
    })
}
